import { render, staticRenderFns } from "./Profiles.vue?vue&type=template&id=3af8a932"
import script from "./Profiles.vue?vue&type=script&lang=js"
export * from "./Profiles.vue?vue&type=script&lang=js"
import style0 from "./Profiles.vue?vue&type=style&index=0&id=3af8a932&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports